import omit from 'lodash/omit'
import map from 'lodash/map'
import React from 'react';
import styled from 'styled-components'
import PropTypes from 'prop-types';
import ShareButton, {shareButtonPropTypes} from './share-button';

/**
 * Render a list of `ShareButton`s, one for each of the given `sites`. All the
 * rest of the props are passed through to each `ShareButton`, which will
 * handle rendering a share button as required. This is a convenience
 * component to provide consistent styling for a group of `ShareButton`s that
 * share the same content to different social sites.
 *
 * @type {{[p: string]: *}} sites - ordered (left-to-right) list of sites to
 *  render buttons for
 * @param url - passed on to ShareButton - the url of the content being shared
 * @param hashtag - passed on to ShareButton - do not include the # character
 *  e.g. 'glowforge'
 * @param text - passed on to ShareButton - the primary short-text to
 *  pre-populate share content
 * @param quote - passed on to ShareButton - a quote from Glowforge to include
 *  alongside the url
 * @param image - passed on to ShareButton - an image to share (only supported
 *  by pinterest)
 * @param props.size - passed on to SocialIcon - standard sizes small, medium,
 *  or large
 * @param props.appearance - passed on to SocialIcon - available styles square,
 *  round, clear
 * @param props.className - styled className
 */
const ShareGroup = ({
  sites,
  className,
  ...childProps
}) => {
  const buttons = map(sites, site => (
    <li className='siteItem' key={site}>
      <ShareButton site={site} {...childProps} />
    </li>
  ));

  return (
    <div className={`ShareGroup ${className}`}>
      <ul className='siteList'>
        {buttons}
      </ul>
    </div>
  );
};

ShareGroup.propTypes = {
  // ShareGroup passes props on to ShareButton, but splits `site` from `sites`
  ...omit(shareButtonPropTypes, ['site']),
  sites: PropTypes.arrayOf(shareButtonPropTypes.site).isRequired,
};

export default styled(ShareGroup)`
  display: inline-block;

  > .siteList > .siteItem {
    display: inline-block;

    // Put margins between items but not before or after them
    &:not(:first-child) {
      margin-left: 0.25rem;
    }
  }
`;
